<template>
    <v-container grid-list-lg class="pa-0 ma-0" fluid>
      
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12 class="pt-0 pb-0">
          <v-card flat :style="!$vuetify.breakpoint.smAndDown ? 'padding-left: 80px; padding-right: 80px; padding-top: 7px; padding-bottom: 7px;' : 'padding-top: 15px; padding-bottom: 15px;'">
            <v-card-title class="pt-0 pb-0">
              <v-layout row wrap :align-center="$vuetify.breakpoint.smAndUp" :align-content-center="$vuetify.breakpoint.smAndDown">

                <v-flex xs12 sm3 md2 lg1 :style="filtroComputed.filtroDataString() == 'Datas' ? 'margin-right: 10px;' : !$vuetify.breakpoint.smAndDown ? 'margin-right: 55px;' : ''">
                  <v-menu
                    v-model="filtro.data.opened"
                    :close-on-content-click="false"
                    offset-y
                    transition="slide-y-transition"
                    :full-width="$vuetify.breakpoint.smAndDown"
                  >
                    <v-btn
                      color="primary"
                      round
                      :outline="filtroComputed.filtroDataString() == 'Datas'"
                      :block="$vuetify.breakpoint.smAndDown"
                      slot="activator"
                    >{{filtroComputed.filtroDataString()}}</v-btn>
                    <v-card>
                      <v-layout row wrap >
                        <v-flex xs5 class="ma-3 text-xs-center">
                          <b><span class="primary--text">Data Inicial</span></b>
                          <br><br>
                          <v-date-picker
                            id="filtroDataInicioDatePicker"
                            v-model="filtro.data.dataInicio"
                            header-color="primary"
                            locale="pt-br"
                            :max="(new Date()).toISOString().substring(0, 10)"
                          ></v-date-picker>
                        </v-flex>
                        <v-flex xs5 class="ma-3 text-xs-center">
                          <b><span class="primary--text">Data Final</span></b>
                          <br><br>
                          <v-date-picker
                            id="filtroDataFimDatePicker"
                            v-model="filtro.data.dataFim"
                            header-color="primary"
                            locale="pt-br"
                            :max="(new Date()).toISOString().substring(0, 10)"
                          ></v-date-picker>
                        </v-flex>
                      </v-layout>
                      <v-card-actions>
                        <v-layout>
                          <v-btn
                            @click="filtroFunctions().limparDatas()"
                            color="primary"
                            flat
                            small
                          >Limpar</v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            @click="filtroFunctions().aplicarDatas()"
                            color="primary"
                            flat
                            small
                          >Aplicar</v-btn>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm3 md2 lg1>
                  <v-menu
                    v-model="filtro.seguradora.opened"
                    :close-on-content-click="false"
                    offset-y
                    transition="slide-y-transition"
                    :full-width="$vuetify.breakpoint.smAndDown"
                  >
                    <v-btn
                      color="primary"
                      round
                      :outline="filtroComputed.filtroSeguradoraString() == 'Seguradoras'"
                      slot="activator"
                      :block="$vuetify.breakpoint.smAndDown"
                    >{{filtroComputed.filtroSeguradoraString()}}</v-btn>
                    <v-card :max-width="!$vuetify.breakpoint.smAndDown ? '200px' : ''">
                      <v-layout row wrap class="pb-0 pa-3">
                        <v-flex xs12 v-for="seguradora in lstSeguradoras" :key="seguradora.id">
                          <v-btn
                            @click="filtroFunctions().selecionarSeguradora(seguradora)"
                            :color="getSeguradoraSelecionadaNomeFiltro == seguradora.nome ? 'primary' : 'themeGrey'"
                            round
                            block
                            :outline="getSeguradoraSelecionadaNomeFiltro != seguradora.nome"
                          >{{seguradora.nome}}</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-menu>
                </v-flex>

              </v-layout>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>

      <v-container class="ml-82 mr-82 pa-24">
      <v-layout row wrap>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-card>
              <v-card-title>
                <v-flex text-xs-center>
                  <h3>{{ charts.chart1.title }}</h3>
                </v-flex>
              </v-card-title>
              <pie-chart :data="charts.chart1.data" :library="optionsPieChart"></pie-chart>
              <v-card-text>
                <v-flex text-xs-center>
                  Total: {{ toMoneyString(charts.chart1.total) }}
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6>
            <v-card>
              <v-card-title>
                <v-flex text-xs-center>
                  <h3>{{ charts.chart2.title }}</h3>
                </v-flex>
              </v-card-title>
              <pie-chart :data="charts.chart2.data" :library="optionsPieChartPct"></pie-chart>
              <v-card-text>
                <v-flex text-xs-center>
                  Total: {{ toPercentString(charts.chart2.total) }}
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6>
            <v-card>
              <v-card-title>
                <v-flex text-xs-center>
                  <h3>{{ charts.chart3.title }}</h3>
                </v-flex>
              </v-card-title>
              <pie-chart :data="charts.chart3.data" :library="optionsPieChart"></pie-chart>
              <v-card-text>
                <v-flex text-xs-center>
                  Total: {{ toMoneyString(charts.chart3.total) }}
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6>
            <v-card>
              <v-card-title>
                <v-flex text-xs-center>
                  <h3>{{ charts.chart4.title }}</h3>
                </v-flex>
              </v-card-title>
              <pie-chart :data="charts.chart4.data" :library="optionsPieChart"></pie-chart>
              <v-card-text>
                <v-flex text-xs-center>
                  Total: {{ toMoneyString(charts.chart4.total) }}
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </v-container>
</template>

<script>
import CustomFormat from '@/helpers/custom-format'
import axios from 'axios'
import permissoes from '@/helpers/permissoes'
import usuarioHelper from '@/helpers/usuario-logado';

export default {
  name: 'Dashboard',
  data: function() {
    return {
      lstSeguradoras: null,
      seguradoraSelecionada: null,
      optionsPieChart: {
        title: {
          display: false
        },
        legend: {
          position: this.$vuetify.breakpoint.smAndDown?'bottom':'right',
          onClick: (e) => e.stopPropagation()
        },
        animation: {
          animateScale: true
        },
         tooltips: {
          enabled: true,
          callbacks: {
            label: function (tooltipItems, data) {

              return data.labels[tooltipItems.index] + ': ' + CustomFormat.toMoneyString(data.datasets[0].data[tooltipItems.index]);
            }
          }
        },
      },
      optionsPieChartPct: {
        title: {
          display: false
        },
        legend: {
          position: this.$vuetify.breakpoint.smAndDown?'bottom':'right',
          onClick: (e) => e.stopPropagation()
        },
        animation: {
          animateScale: true
        },
         tooltips: {
          enabled: true,
          callbacks: {
            label: function (tooltipItems, data) {

              return data.labels[tooltipItems.index] + ': ' + CustomFormat.toPercentString(data.datasets[0].data[tooltipItems.index]);
            }
          }
        },
      },
      charts: {
        chart1: {
          title: 'Total de prêmios',
          data: null,
          total: 0
        },
        chart2: {
          title: 'Porcentagem de Prêmios Convertidos',
          data: null,
          total: 0
        },
        chart3: {
          title: 'Solicitações apresentadas para CIA',
          data: null,
          total: 0
        },
        chart4: {
          title: 'Solicitações Convertidas',
          data: null,
          total: 0
        }
      },
      filtro: {
        seguradora: {
          opened: false,
          selecionada: null
        },
        data: {
          opened: false,
          dataInicio: null,
          dataFim: null,
          aplicado: {
            dataInicio: null,
            dataFim: null,
            formatado: {
              dataInicio: null,
              dataFim: null
            }
          }
        }
      }
    }
  },
  computed: {
    filtroComputed: function() {
      const self = this;
      return {
        filtroDataString: function() {
          if (self.filtro.data.aplicado.dataInicio || self.filtro.data.aplicado.dataFim) {
            if (self.filtro.data.aplicado.dataInicio && self.filtro.data.aplicado.dataFim) {
              return `${self.filtro.data.aplicado.formatado.dataInicio} - ${self.filtro.data.aplicado.formatado.dataFim}`;
            } else if (self.filtro.data.aplicado.dataInicio) {
              return `${self.filtro.data.aplicado.formatado.dataInicio} - Hoje`;
            } else if (self.filtro.data.aplicado.dataFim) {
              return `Todas - ${self.filtro.data.aplicado.formatado.dataFim}`;
            }
          } else {
            return 'Datas';
          }
        },
        filtroSeguradoraString: function() {
          if (self.filtro.seguradora.selecionada) {
            return self.filtro.seguradora.selecionada.nome;
          } else if (self.filtro.seguradora.selecionada == 'Todas') {
            return 'Todas'
          } else {
            return 'Seguradoras';
          }
        }
      }
    },
    getSeguradoraSelecionadaNomeFiltro: function() {
      if (this.filtro.seguradora.selecionada && this.filtro.seguradora.selecionada != 'Todas') {
        return this.filtro.seguradora.selecionada.nome;
      } else {
        return '';
      }
    },
    getSeguradoraSelecionadaFiltro: function() {
      if (this.filtro.seguradora.selecionada && this.filtro.seguradora.selecionada != 'Todas') {
        return this.filtro.seguradora.selecionada;
      } else {
        return {};
      }
    }
  },
  watch: {
    "filtro.data.aplicado.dataInicio": function(val) {
      this.filtro.data.aplicado.formatado.dataInicio = CustomFormat.parseDateToFormatedStringWithMonthName(val);
      this.atualizarDashboard();
    },
    "filtro.data.aplicado.dataFim": function(val) {
      this.filtro.data.aplicado.formatado.dataFim = CustomFormat.parseDateToFormatedStringWithMonthName(val);
      this.atualizarDashboard();
    }
  },
  mounted: function () {
    this.carregaSeguradoras();
    this.atualizarDashboard();
  },
  methods: {
    getPermissao: function (requested, param) {
      const permissionObj = permissoes;
      if (param) {
        return eval('permissionObj.' + this.$route.name + '.' + requested + "(" + param + ")");
      } else {
        return eval('permissionObj.' + this.$route.name + '.' + requested);
      }
    },
    carregaSeguradoras: function () {
        const self = this;
        self.filtro.data.aplicado.dataFim = (new Date()).toISOString().substring(0, 10);
        axios.get(`${process.env.URL_SEGURADORAMS}/v1/no-auth/buscaTodasSeguradoras`)
          .then((response) => {
            const data = response.data;
            if (data) {
              self.lstSeguradoras = data.sort((a, b) => { return a.nome.localeCompare(b.nome) });
              self.lstSeguradoras.unshift({id:0, nome: 'Todas'})
              self.seguradoraSelecionada = self.lstSeguradoras[0];
            }
          }).catch((err) => {
            console.log(err);
          });
    },
    atualizarDashboard: function () {
      const self = this;
      if (!self.filtro.seguradora.selecionada || self.filtro.seguradora.selecionada == 'Todas') {
        self.atualizarDashboardTodasSeguradoras();
      } else {
        self.atualizarDashboardFiltroSeguradoras(self.filtro.seguradora.selecionada.id);          
      }
    },
    atualizarDashboardTodasSeguradoras: function () {
      const self = this;
      self.$store.commit('startLoading');

      var url = `${process.env.URL_SEGURADORAMS}/v1/buscaDashboard?id=0`
      if(self.filtro.data.aplicado.dataInicio) {
        url = url + '&dataInicio=' + self.filtro.data.aplicado.dataInicio;
      }
      if(self.filtro.data.aplicado.dataFim) {
        url = url + '&dataFim=' + self.filtro.data.aplicado.dataFim;
      }
      axios.get(url, {
          headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }
      })
      .then((response) => {
        const data = response.data;
        self.charts.chart1.data = Object.entries(data.cotacoesPorStatus);
        self.charts.chart2.data = Object.entries(data.porcentagemPremiosConvertidos);
        self.charts.chart3.data = Object.entries(data.cotacoesAceitasOuNaoAceitas);
        self.charts.chart4.data = Object.entries(data.cotacoesConvertidas);
        Object.keys(self.charts).forEach( function(key) {
          var total = 0;
          if(self.charts[key].data)    
            self.charts[key].data.forEach(element => { 
              total += element[1]; 
              element[1] = element[1].toFixed(2);
            });
          self.charts[key].total = total;
        })
        self.$store.commit('endLoading');
      })
      .catch(err => {
        self.$store.commit('endLoading');
      });
    },
    atualizarDashboardFiltroSeguradoras: function (idSeguradora) {
      const self = this;
      self.$store.commit('startLoading');
      var url = `${process.env.URL_SEGURADORAMS}/v1/buscaDashboard?id=${idSeguradora}`
      if(self.filtro.data.aplicado.dataInicio) {
        url = url + '&dataInicio=' + self.filtro.data.aplicado.dataInicio;
      }
      if(self.filtro.data.aplicado.dataFim) {
        url = url + '&dataFim=' + self.filtro.data.aplicado.dataFim;
      }
      axios.get(url, {
          headers: { 'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}` }
      })
      .then((response) => {
        const data = response.data;
        self.charts.chart1.data = Object.entries(data.cotacoesPorStatus);
        self.charts.chart2.data = Object.entries(data.porcentagemPremiosConvertidos);
        self.charts.chart3.data = Object.entries(data.cotacoesAceitasOuNaoAceitas);
        self.charts.chart4.data = Object.entries(data.cotacoesConvertidas);
        Object.keys(self.charts).forEach( function(key) {
          var total = 0;
          if(self.charts[key].data)    
            self.charts[key].data.forEach(element => { 
              total += element[1]; 
              element[1] = element[1].toFixed(2) * 1;
            });
          self.charts[key].total = total;
        })

        self.$store.commit('endLoading');
      })
      .catch(err => {
        self.$store.commit('endLoading');
      });
    },
    toMoneyString: function (val) {
      return CustomFormat.toMoneyString(val);
    },
    toPercentString: function (val) {
      return CustomFormat.toPercentString(val);
    },
    filtroFunctions: function() {
      const self = this;
      return {
        aplicarDatas: function() {
          self.filtro.data.aplicado.dataInicio = self.filtro.data.dataInicio;
          self.filtro.data.aplicado.dataFim = self.filtro.data.dataFim;
          self.filtro.data.opened = false;
        },
        limparDatas: function() {
          self.filtro.data.aplicado.dataInicio = null;
          self.filtro.data.aplicado.dataFim = null;
          self.filtro.data.dataInicio = null;
          self.filtro.data.dataFim = null;
          self.filtro.data.opened = false;
        },
        selecionarSeguradora: function(seguradoraSelecionada) {
          if (seguradoraSelecionada) {
            self.filtro.seguradora.selecionada = seguradoraSelecionada;
            self.filtro.seguradora.opened = false;
            self.atualizarDashboard();
          }
        }
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/dashboard/Dashboard.vue